import { getRecommendationStore } from '@/stores/recommendation';

import { ToggleMoreVideos } from './toggle_more_videos';
import { TrackVideoClick } from './track_video_click';

const recommendationStore = getRecommendationStore();
const trackVideoClick = new TrackVideoClick(recommendationStore);

Alpine.data('toggleMoreVideos', () => new ToggleMoreVideos(trackVideoClick));
